import React, { useState, useEffect } from 'react'
import { collection, query, where, getDocs } from 'firebase/firestore'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { useUserAuth } from '../../context/UserAuthContext'
import DateFinder from '../dataFinder/DateFinder'
import UserNameFinder from '../dataFinder/UserNameFinder'
import init from '../../firebase'
const Reviews = () => {
    const [data, setData] = useState([])
    const { user } = useUserAuth();
    const [loading, setLoading] = useState(true)
    const merchant_id = user.uid;
    const getReview = async () => {
        const mycollection = collection(init.db, 'ratings');
        let q = query(mycollection, where('vendor_id', '==', merchant_id));
        const data = await getDocs(q);
        setData(data.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setLoading(!loading)
    }
    useEffect(() => {
        getReview()
    }, [merchant_id])
    return (
        <div className='page-wrapper'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='table-responsive '>
                                    <table className='table table-bordered text-center table-hover  padding-bottom: 100px'>
                                        <thead >
                                            <tr className='bg-secondary'>
                                                <th className='text-white'>Rating</th>
                                                <th className='text-white'>Review</th>
                                                <th className='text-white'>Date</th>    
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                loading && (
                                                    <>
                                                        <tr>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                        </tr>
                                                    </>
                                                )
                                            }

                                            {
                                                !loading && data?.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <img src="https://img.freepik.com/premium-vector/young-smiling-man-avatar-man-with-brown-beard-mustache-hair-wearing-yellow-sweater-sweatshirt-3d-vector-people-character-illustration-cartoon-minimal-style_365941-860.jpg" style={{ height: '60px', width: '60px', borderRadius: "50%" }} alt="" />
                                                                <p> ( {item.rating})</p>
                                                            </td>

                                                            <td>
                                                                <h5><UserNameFinder user_id={item.user_id} /></h5>
                                                                <p style={{ textAlign: 'justify' }}>{item.review}</p>
                                                            </td>
                                                            <td style={{ width: '15%' }}>
                                                                <i className="fa-solid fa-calendar" style={{ fontSize: "40px", color: "" }}></i>
                                                                <p><DateFinder mydate={item.createdAt?.seconds} /></p>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reviews